export const DEFAULT_WHATSAPP_NUMBER = '5491126597907';

export const buildWhatsappLink = (number, text) => {
    const base = `https://wa.me/${number || DEFAULT_WHATSAPP_NUMBER}`;
    return text ? `${base}?text=${encodeURIComponent(text)}` : base;
};
